import React from 'react';
import { View, Text } from 'react-native';
import { Utils } from './Utils';

export default function Weekdays(props) {
  const {
    styles,
    firstDay,
    currentMonth: month,
    currentYear: year,
    weekdays,
    dayLabelsWrapper,
    customDayHeaderStyles,
    dayLabelsStyle,
  } = props;

  // dayOfWeekNums: ISO week day numbers
  const dayOfWeekNums = Utils.getISOWeekdaysOrder(firstDay);
  let wd = weekdays;
  if (!wd) {
    wd = firstDay ? Utils.getWeekdays(firstDay) : Utils.WEEKDAYS; // English Week days Array
  }

  return (
    <View style={[styles.dayLabelsWrapper, dayLabelsWrapper]}>
      {wd.map((day, key) => {
        const dayOfWeekTextStyle = [styles.dayLabels];
        let customDayOfWeekStyles = {};
        if (customDayHeaderStyles instanceof Function) {
          const dayOfWeek = dayOfWeekNums[key];
          customDayOfWeekStyles = customDayHeaderStyles({ dayOfWeek, month, year }) || {};
          dayOfWeekTextStyle.push(customDayOfWeekStyles.textStyle);
        }
        return (
          <View style={[customDayOfWeekStyles.style, { flex: 1 }]} key={key}>
            <Text style={[dayOfWeekTextStyle, dayLabelsStyle]}>
              {day}
            </Text>
          </View>
        );
      })
      }
    </View>
  );
}
